import type { SliceStateFromReducer } from 'shared/types';

import type { whiteLabelUserDataSlice } from './whiteLabelUserData.model';

type TWhiteLabelUserDataStore = SliceStateFromReducer<typeof whiteLabelUserDataSlice>;

export const whiteLabelUserDataTokenSelector = (state: TWhiteLabelUserDataStore) => state.whiteLabelUserData.token;
